// frontend/src/lib/editorNavigation.js
//
// Navigation policy for the editor save flow.
//
// EditorPage is shared by the public user editor (/editor/:id) and the
// Designer Portal (/designer/editor), plus creator and admin-template contexts.
// After a NEW plain user design is saved, the editor adopts the new id by
// redirecting to /editor/:id so reloads work and subsequent saves PUT in place.
//
// That redirect must NEVER fire from a Portal context: bouncing a designer into
// /editor/:id drops the Designer Portal chrome (e.g. the Submit-for-Approval
// action) and strands them in the public editor. Designer / creator / admin
// saves persist through their own endpoints and stay on their own routes.
export function shouldRedirectToUserEditor(ctx = {}) {
  const { isDesignerMode, isCreatorMode, isAdminTemplateEdit } = ctx;
  return !isDesignerMode && !isCreatorMode && !isAdminTemplateEdit;
}
